import type { FC, ReactNode } from 'react'

import { createElement, useRef } from 'react'
import { gsap, useGSAP, MOTION_QUERY } from '@/lib/gsap'

interface RevealProps {
    children: ReactNode
    className?: string
    as?: 'div' | 'section' | 'ul' | 'ol' | 'article' | 'figure' | 'dl' | 'aside'
    selector?: string
    y?: number
    stagger?: number
    delay?: number
    start?: string
    id?: string
}

export const Reveal: FC<RevealProps> = ({
    children,
    className,
    as = 'div',
    selector,
    y = 40,
    stagger = 0.08,
    delay = 0,
    start = 'top 86%',
    id
}): ReactNode => {
    const ref = useRef<HTMLElement>(null)

    useGSAP(() => {
        const element = ref.current

        if (!element) return

        const media = gsap.matchMedia()

        media.add(MOTION_QUERY, () => {
            const targets = selector ? gsap.utils.toArray<HTMLElement>(selector, element) : [element]

            if (!targets.length) return

            gsap.from(targets, {
                y,
                autoAlpha: 0,
                duration: 1.15,
                ease: 'expo.out',
                stagger,
                delay,
                scrollTrigger: { trigger: element, start, once: true }
            })
        })

        return () => media.revert()
    }, { scope: ref })

    return createElement(as, { ref, className, id }, children)
}
